import type {Icon} from '@primer/octicons-react'
import {
  BlockType,
  type FilterProviderOptions,
  type FilterProviderType,
  type AnyBlock,
  type MutableFilterBlock,
  type SuppliedFilterProviderOptions,
  type FilterKey,
  type FilterValueValidator,
  type IndexedBlockValueItem,
  type WithRequiredProperty,
} from '../types'
import {defaultFilterProviderOptions} from '../constants/defaults'
import {capitalize, shouldProviderShowSuggestions} from '../utils'
import type {FilterQuery} from '../filter-query'

export class RootFilterProvider implements WithRequiredProperty<FilterKey, 'options'> {
  key: string
  displayName: string
  description?: string
  priority: number
  type: FilterProviderType
  icon: Icon
  options: FilterProviderOptions

  constructor(filterKey: FilterKey, options?: SuppliedFilterProviderOptions) {
    Object.assign(this, filterKey)
    this.displayName = filterKey.displayName ?? capitalize(filterKey.key)

    this.options = {
      ...defaultFilterProviderOptions,
      priority: filterKey.priority,
      ...options,
      filterTypes: {...defaultFilterProviderOptions.filterTypes, ...options?.filterTypes},
    }
    this.priority = this.options.priority
  }

  shouldGetSuggestions(filterBlock: AnyBlock | MutableFilterBlock): boolean {
    return (
      filterBlock &&
      filterBlock.type !== BlockType.Space &&
      shouldProviderShowSuggestions(filterBlock, this.options.filterTypes.multiValue)
    )
  }
}

export class ValueValidator<T = unknown> extends RootFilterProvider implements FilterValueValidator<T> {
  validateValue(
    filterQuery: FilterQuery,
    value: IndexedBlockValueItem,
    data: T | null,
  ): false | Partial<IndexedBlockValueItem> | null | undefined {
    if (!data) return false

    return data
  }
}
